import { PageSection } from '../../Layout';
import { DriverInterfacingSection } from '../Driver';

const CompressionMachine = () => {
  return (
    <PageSection>
      <DriverInterfacingSection />
    </PageSection>
  );
};

export default CompressionMachine;
export { CompressionMachine };
